import React from 'react';
import { IIcon, useIconProps } from '@components-library/Icons/iconsComponents/useIconProps';
import FileIconSvgIcon from './file.svgrIcon.svg';

export const FileIcon = React.forwardRef(({ ...props }: IIcon, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
  });

  return <FileIconSvgIcon {...iconProps} />;
});
